export default __webpack_public_path__ + "static/media/haven.9438e5d5.jpeg";